import api from '@/apis/di/sysRoleAPI.js';
import Crud from '@/stores/crudBase';
var crud = new Crud('sysRole', api);

const state = {
  ...crud.state,
  _config: {
    table: 'sys_role',
    field: {
      key: 'role_id',
      code: 'role_code',
      name: 'role_name',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
  /**
   * Cập nhân quyền cho bản ghi trong grid sau khi cập nhật phân quyền
   * @param {*} state
   * @param {*} data
   * TTLONG 03/12/2022
   */
  updateGrid(state, data) {
    state.items.forEach(element => {
      if (element.role_id === data.role_id) {
        element.permissions = data.permissions;
        element.is_budget_permission = data.is_budget_permission;
      }
    });
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
